export var CoverageStatus;
(function (CoverageStatus) {
    CoverageStatus["Pending"] = "pending";
    CoverageStatus["RestrictiveDecisions"] = "restrictive_decisions";
    CoverageStatus["Accepted"] = "accepted";
    CoverageStatus["Archived"] = "archived";
})(CoverageStatus || (CoverageStatus = {}));
